import { createFileRoute } from "@tanstack/react-router";
import { AttributionsPage } from "@/features/attributions/AttributionsPage";
export const Route = createFileRoute("/_authenticated/_protected/open-source")({ component: AttributionsPage });
